// extracted by mini-css-extract-plugin
module.exports = {"primaryOrange":"_3_UGal1-"};